/**
 * ページTopへ戻るボタン
 *
 */

import jump from 'jump.js';

export default () => {
  const topbtns = document.querySelectorAll('.js-toTop');
  topbtns.forEach((topbtn) => {
    topbtn.addEventListener('click', (event) => {
      event.preventDefault();
      jump('html', {
        duration: 500,
        offset: 0,
      });
    });
  });
};
